import { Controller } from 'stimulus';
import { generateParamsForActorSetAttributes } from "../packs/filter_helpers"

export default class extends Controller {
  static targets = ['filterContent'];
  beforeFilter() {
    this.progressBar = new Turbolinks.ProgressBar();
    this.progressBar.setValue(0);
    this.progressBar.show();
  }

  afterFilter() {
    this.progressBar.setValue(1);
    this.progressBar.hide();
  }

  filter(event) {
    var listContainerCLass = 'list-dropdown-filter'
    var checked = this.checkedList(listContainerCLass);
    var url = '/monitoring';
    this.beforeFilter();
    let params = new URLSearchParams(window.location.search)
    if ($(event.target).val() == "all-junkipedia") $(`${listContainerCLass}`).prop("checked", false);
    ($(`.${listContainerCLass}:checked`).length <= 0) ? params.delete("lists") : params.set("lists",checked.join(","));
    if ($(event.target).val() == "all-junkipedia") params.set("lists","all-junkipedia")
    var url = window.location.origin + window.location.pathname + "?" + params;
    // window.history.pushState({ turbolinks: true, url: url }, '', url);
    // this.sendFilterAjaxCall(url, data);
    window.location.href = url
  }

  searchKeyFilter(event) {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    let updated_params = generateParamsForActorSetAttributes(event, params)
    window.location.href = window.location.href.split('?')[0] + '?' + updated_params.toString()
  }

  sendFilterAjaxCall(url, data) {
    Rails.ajax({
      type: 'GET',
      url: url,
      data: data,
      success: (response) => {
        $("body").html($(response.body));
        this.afterFilter();
      }
    });
  }

  checkedList(listContainerCLass, replace_str=null) {
    var checked = [];
    $(`.${listContainerCLass}:checked`).each(function() {
      if($(this).attr('id') != undefined) {
        var id = $(this).attr('id').replace("list-", "");
        if(replace_str) id = id.replace(replace_str, "");
        checked.push(id);
      }
    })
    return checked;
  }

  setChannelFilters(event){
    const filterType = event.target.dataset.filterType
    var checked = this.checkedList(`${filterType}-dropdown-filter`);
    let params = new URLSearchParams(window.location.search)
    params.delete(`${filterType}[]`)
    checked.map(function(value) {
      params = params +`&${filterType}[]=`+value;
    });
    params = new URLSearchParams(params)
    window.location.href = window.location.href.split('?')[0] + '?' + params
  }

  setPlatformFilter(){
    var checked = this.checkedList('platform-dropdown-filter');
    let params = new URLSearchParams(window.location.search)
    params.delete('platform_name[]')
    checked.map(function(value) {
      params = params +`&platform_name[]=`+value ;
    });
    window.location.href = window.location.href.split('?')[0] + '?' + params
  }

  applyEngagementFilter(){
    let params = new URLSearchParams(window.location.search)
    $(".engagement-select2").each(function(i, elem){
      params.delete($(this).data("param-name"))
    })

    $(".engagement-select2").each(function(i, elem){
      if($(this).val()) params = params +`&${$(this).data("param-name")}=`+$(this).val();
    })

    console.log(params.toString())
    window.location.href = window.location.href.split('?')[0] + '?' + params
  }
  
  loadFilterDropdown(event) {
    if (!this.hasFilterContentTarget) return
    
    // Prevent loading if already loaded
    if (this.filterContentTarget.dataset.loaded === 'true') return
    
    // Get the model type from the data attribute
    const modelType = event.currentTarget.dataset.modelType
    const search = window.location.search || ''

    let data = modelType.includes("_attributes") ? {filter_type: event.currentTarget.dataset.filterType} : {}
    const url = modelType.includes("_attributes") ? `/projects/filter_dropdown${search}` : `/${modelType}/filter_dropdown${search}`

    if (window.location.pathname.includes("/actor_sets/")){
      data = {...data, actor_set_id: window.location.pathname.split("/").pop()}
    }
    
    this.filterContentTarget.innerHTML = '<div class="text-center p-4"><i class="fas fa-spinner fa-spin"></i> Loading...</div>'
    
    Rails.ajax({
      type: 'GET',
      url: url,
      data: $.param(data),
      dataType: 'json',
      success: (response) => {
        // Insert the response HTML into the dropdown content
        if (response && response.entries) {
          this.filterContentTarget.innerHTML = response.entries
          this.filterContentTarget.dataset.loaded = 'true'
        }
      },
      error: () => {
        this.filterContentTarget.innerHTML = '<div class="p-3">Failed to load filter options</div>'
      }
    })

    $(this.filterContentTarget).click(function(e){
      e.stopPropagation()
    })
  }

  setPostTypeFilter(){
    var parameter_types = []

    $(".parameter-name").each(function(i, elem){
      parameter_types.push($(this).data("name"))
    })

    let params = new URLSearchParams(window.location.search)

    parameter_types.forEach(function(val){
      var parameter_name = `${val}[]`
      params.delete(parameter_name)
    })

    $(`.post-type-dropdown-filter:checked`).each(function() {
      if($(this).attr('id') != undefined) {
        var value = $(this).val();
        var param_name = $(this).data("param-name");
        params.append(`${param_name}[]`, value)
        // params = params +`&${param_name}[]=`+value;
      }
    })
    
    console.log(params)
    window.location.href = window.location.href.split('?')[0] + '?' + params
  }
  
  setModelFilter(event){
    var filter_name = event.target.getAttribute("data-name")
    var checked = this.checkedList(`${filter_name}-dropdown-filter`, `${filter_name}-`);

    let params = new URLSearchParams(window.location.search)
    var parameter_name = `${filter_name}_id[]`
    // if(location.pathname == "/channels") parameter_name = 'post_filters[language_code][]'

    params.delete(parameter_name)
    checked.map(function(value) {
      params = params +`&${parameter_name}=`+value ;
    });
    window.location.href = window.location.href.split('?')[0] + '?' + params
      
  }

  viewFilter(event){
    let params = new URLSearchParams(window.location.search)
    params.set('view_as', event.target.value);
    if (event.target.value == "show_labels"){ 
      params.set('view', event.target.value);
      params.set('view_as', "tags");
    }
    if (event.target.value != "show_labels")  params.delete('view');
    window.location.href = window.location.href.split('?')[0] + '?' + params
  }

  exportCSV(event){
    var path = $(event.target).data("path");
    let params = new URLSearchParams(window.location.search);

    var checked = this.checkedList('csv-columns-dropdown-filter');

    checked.map(function(value) {
      params = params +`&column_list[]=`+value ;
    }); 

    if($("#extraParams").val()){
      params = params +`&${$("#extraParams").val()}` ;
    }

    Rails.ajax({
      type: 'POST',
      url: path + "?" + params,
      success: (response) => {
        console.log(response)
        $('#csvExportModal').modal('hide');
      },
      failure: (response) => {
        $('#csvExportModal').modal('hide');
      }
    });

  }

  // checkOnly(event) {
  //   $(".list-filter").prop("checked", false);
  //   var current_list_id = $(event.target).parent().find("input").attr("id");
  //   if(current_list_id == undefined) {
  //     var current_group_id = $(event.target).parent().find("input").data("group-id");
  //     $(".group-" + current_group_id).prop("checked", true);
  //   } else {
  //     $("#" + current_list_id).prop("checked", true);
  //   }
  //   this.filter(event);
  // }

  // toggleAll(event) {
  //   var listContainerCLass = event.target.className.includes('list-dropdown-filter') ? 'list-dropdown-filter' : 'list-filter'
  //   $(".checkbox-li").removeClass("d-none");
  //   $("#list-all-junkipedia").prop("checked", false);
  //   var toggle = $(event.target).prop('checked');
  //   $(`.${listContainerCLass}`).prop("checked", toggle);
  //   this.filter(event);
  // }

  toggleGroupFilter(event) {
    var toggle = $(event.target).prop('checked');
    var gID = $(event.target).data("group-id");
    $(".group-" + gID).prop("checked", toggle);
    $("#collapse-group-"+gID).addClass('show')
    event.stopPropagation();
  }

  searchQuery(event) {
    event.preventDefault();
    this.beforeFilter();
    var url = $(event.target).attr("action");
    

    var parameter_name = "keyword"
    var field_id = "#keyword"
    if(location.pathname == "/channels"){
      parameter_name = 'post_filters[keyword]'
      field_id = '#post_filters_keyword'
    }

    if(location.pathname == "/project_posts"){
      parameter_name = 'term'
      field_id = '#term'
    }

    var transcript_text_checkbox = $('#transcript_text_checkbox')
    var image_text_checkbox = $('#image_text_checkbox')
    var post_text_checkbox = $('#post_text_checkbox')

    let params = new URLSearchParams(window.location.search)
    var keyword = $(field_id).val();

    if(keyword == null || keyword == '') {
      params.delete(parameter_name);
    } else if(keyword != params.get(parameter_name)) {
      params.set(parameter_name,keyword);
    }

    parameter_name = "simple_query"
    if(location.pathname == "/channels") parameter_name = 'post_filters[simple_query]'

    var query_checkbox = $('#query_string_checkbox')
    if (query_checkbox){
      if(query_checkbox.prop('checked')){
        params.set(parameter_name, true);
      } else {
        params.delete(parameter_name);
      }
    }

    parameter_name = "substring_search"
    if(location.pathname == "/channels") parameter_name = 'post_filters[substring_search]'

    var substring_search_checkbox = $('#substring_search_checkbox')
    if (substring_search_checkbox){
      if(substring_search_checkbox.prop('checked')){
        params.set(parameter_name, true);
      } else {
        params.delete(parameter_name);
      }
    }

    if(transcript_text_checkbox) {
      if(transcript_text_checkbox.prop('checked')){
        params.set('transcript_search_enabled', true)
      } else {
        params.delete('transcript_search_enabled')
      }
    }

    if(image_text_checkbox) {
      if(image_text_checkbox.prop('checked')){
        params.set('image_text_search_enabled', true)
      } else {
        params.delete('image_text_search_enabled')
      }
    }

    if(post_text_checkbox) {
      if(post_text_checkbox.prop('checked')){
        params.set('post_text_search_enabled', true)
      } else {
        params.delete('post_text_search_enabled')
      }
    }


    if (location.pathname == "/project_posts" && (keyword == null || keyword == '')) {
      params.delete("simple_query")
    }

    url += "?" + params
    console.log(url)

    // window.history.pushState({ turbolinks: true, url: url }, '', url);
    // this.sendFilterAjaxCall(url, data);
    window.location.href = url
  }


  toggleFolderIcon(event) {
    var i = $(event.target).find("i");
    var gID = $(event.target).data("group-id");
    if(i.length == 0) i = $(event.target);
    if(i.hasClass('fa-folder-open')) {
      i.removeClass('fa-folder-open');
      i.removeClass('text-warning');
      i.addClass('fa-folder');
      i.addClass('text-primary');
      $("#collapse-group-"+gID).removeClass('show')
      $("#collapse-group-"+gID).addClass('collapse')
    } else {
      i.addClass('fa-folder-open');
      i.removeClass('fa-folder');
      i.addClass('text-warning');
      i.removeClass('text-primary');
      $("#collapse-group-"+gID).addClass('show')
      $("#collapse-group-"+gID).removeClass('collapse')
    }
  }
}
